module.exports = __webpack_public_path__ + "static/media/VirginiaMason.1097eb4b.png";